import axiosInstance from './axiosInstance'

export const migrateLatestZohoContacts = () => {
  return axiosInstance.get('/zoho/migrate-latest-contacts')
}

export const migrateLatestZohoOpportunities = () => {
  return axiosInstance.get('/zoho/migrate-latest-opportunities')
}
